import React from 'react'
import { observer } from 'mobx-react'
import { Column } from '@morningtrain/react-columns'
import { Avatar as AvatarDisplay } from 'support/displays'

function Avatar (props) {
  return (
    <Column {...props}>
      <AvatarDisplay name='avatar_url'/>
    </Column>
  )
}

export default observer(Avatar)